var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MobileBasePage } from '../../core/base/mobile-base-page';
import { Item, OrderManager } from 'aigens-ng-core';
import { AfterViewInit, ChangeDetectorRef, Injector, OnDestroy, OnInit } from '@angular/core';
import { IonFab } from '@ionic/angular';
import { RouteTable } from '../../core/route-table';
import { from, Observable } from 'rxjs';
import { getSetLayout } from '../../shared/utilities/layout-helper';
import { ModifierItemSelectPageModal } from 'src/app/routes/item/modifier-item-select-modal/modifier-item-select-modal';
import { VariationScrollDialog } from 'src/app/dialogs/variation-scroll/variation-scroll';
import { ComboPage } from '../../routes/item/combo-page/combo-page';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { SideBarModifierDialog } from 'src/app/dialogs/sideBarModifier/sideBarModifier';
import { popDrownAnimation, popUpAnimation } from 'src/app/shared/animations/leaveAnimation';
import { MultiStepComboPage } from '../../routes/item/multi-step-combo/multi-step-combo-page.component';
var ItemGridScrollPage = /** @class */ (function (_super) {
    __extends(ItemGridScrollPage, _super);
    function ItemGridScrollPage(injector, cdr) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.cdr = cdr;
        _this.isfabOpen = false;
        _this.isVariationOpened = false;
        _this.isBounce = false; // footer item quantity 变更 的动画控制
        _this.imgs = [];
        _this.soldoutMap = {};
        _this.modifiableMap = {};
        _this.requiredModifierMap = {};
        _this.tagsImage = {};
        _this.variations = {};
        _this.alert = null; // for when ngdestory,can diss modal
        _this.tabClickCount = 0;
        _this.setClickCount = 0;
        _this.adShown = false;
        _this.login = false;
        _this.itemSoldoutMap = {};
        _this.fromBrandStoreList = false;
        _this.normalCategories = [];
        _this.noCat = false;
        _this.isInfiniteScroll = false; // infiniteScroll开关
        _this.itemMap = {};
        _this.imageMap = {};
        _this.categoryMap = {};
        _this.allAvailableItems = [];
        _this.catArray = [0];
        _this.scrollLock = true;
        _this.isBlockRepeatClick = false;
        console.log('TCL: ItemGridPage');
        _this.store = _this.getNavParams('store');
        _this.storeId = _this.store.id;
        _this.categories = _this.getNavParams('categories');
        _this.catImages = [];
        if (_this.categories) {
            for (var _i = 0, _a = _this.categories; _i < _a.length; _i++) {
                var cat = _a[_i];
                _this.catImages.push(cat.getImage('default', 500, false));
            }
        }
        _this.stores = _this.getNavParams('stores');
        _this.storeClicked = _this.getNavParams('storeClicked');
        _this.defaultImage = _this.getDefaultImage(false, _this.store.brand, 500);
        _this.isCatLayoutNone = !_this.settings.catLayout || _this.settings.catLayout === 'none';
        _this.fromBrandStoreList = _this.getNavParams('fromBrandStoreList');
        console.log('show ordermanager', _this.orderManager);
        if (_this.store && _this.store.menu) {
            _this.itemMap = _this.store.menu['imap'];
        }
        _this.isInfiniteScroll = _this.settings['enableInfiniteScroll'] || false;
        // this.isInfiniteScroll = false;
        if (_this.isCatLayoutNone) {
            _this.catLayoutIsNone();
        }
        else {
            _this.category = _this.getNavParams('category');
            console.log('TCL: ItemGridScrollPage -> constructor -> this.category', _this.category);
            _this.mode = _this.getNavParams('layout') ? _this.getNavParams('layout') : _this.settings.itemLayout;
            console.log('item grid construction', _this.mode);
            console.log('this.categories', _this.categories);
            if (_this.multOrderManager.enableMutlOrder) {
                _this.settingMutlOrderManager();
            }
        }
        if (_this.fromBrandStoreList) {
            _this.checkPopup(_this.store);
        }
        return _this;
    }
    ItemGridScrollPage.prototype.showEmpty = function (index) {
        this.catImages[index] = this.defaultImage;
    };
    ItemGridScrollPage.prototype.canDeactivate = function () {
        var _this = this;
        // if any category layout is set in menu settings, then ItemGridPage is not the last page
        if (this.store.menu.catLayout && this.store.menu.catLayout !== 'none') {
            return Observable.of(true);
        }
        var modal = from(this.modalController.getTop());
        {
            modal.subscribe(function (m) {
                if (m) {
                    m.dismiss();
                    _this.navigationService.isAlertingDeactive = false;
                    _this.navigationService.poping = false;
                    _this.navController.setDirection('forward', true, 'forward');
                    window.history.pushState({}, 'Order.Place', window.location.href);
                    // TODO: the history is still popped even the navigation is cancelled so we push it back to history stack.
                    console.log('push state', window.location.href);
                    _this.navigationService.deactivateResult.next(false);
                }
                else {
                    console.log('guard running');
                    // this.navigationService.deactivateResult.next(false);
                    if (_this.multOrderManager.enableMutlOrder) {
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    if (!_this.navigationService.poping) {
                        // this.navController.setDirection('back', true, 'back');
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    if (_this.noCat) {
                        return _this.navigationService.deactivateResult.next(true);
                    }
                    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
                    try {
                        console.log('creating alert?', _this.navigationService.isAlertingDeactive);
                        if (!_this.navigationService.isAlertingDeactive) {
                            _this.navigationService.isAlertingDeactive = true;
                            var alert_1 = _this.alertController.create({
                                header: _this.t.instant('pages.brand-store-list.alert-title'),
                                backdropDismiss: false,
                                buttons: [
                                    {
                                        text: _this.t.instant('buttons.cancel'),
                                        handler: function () {
                                            // to do
                                            // this.googleAnalyticEventTrack('back-button-event', 'cancel');
                                            _this.navigationService.isAlertingDeactive = false;
                                            _this.navigationService.poping = false;
                                            _this.navController.setDirection('forward', true, 'forward');
                                            window.history.pushState({}, 'Order.Place', window.location.href);
                                            // TODO: the history is still popped even the navigation is cancelled so we push it back to history stack.
                                            console.log('push state', window.location.href);
                                            _this.navigationService.deactivateResult.next(false);
                                            // this.navigationService.deactivateResult.complete();
                                        }
                                    },
                                    {
                                        text: _this.t.instant('buttons.leave'),
                                        handler: function () {
                                            // to do
                                            // this.googleAnalyticEventTrack('back-button-event', 'back');
                                            // const key = this.storeId + '.savedOrder';
                                            // this.configService.putPreference(key, null);
                                            _this.navigationService.isAlertingDeactive = false;
                                            _this.navigationService.deactivateResult.next(true);
                                            // this.navigationService.deactivateResult.complete();
                                            // super.backButtonClick();
                                            // return 'ok';
                                        }
                                    }
                                ]
                            });
                            console.log('make alert');
                            alert_1.then(function (data) {
                                console.log('alert created', data);
                                console.log('alert created', _this);
                                data.present().then(function (success) {
                                    console.log('success', success);
                                }, function (reject) {
                                    console.log('reject', reject);
                                });
                            });
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            });
        }
        return this.navigationService.deactivateResult;
    };
    ItemGridScrollPage.prototype.tapSearch = function () {
        this.pushByName('SearchItemPage', { categories: this.categories, store: this.store, storeId: this.storeId });
    };
    ItemGridScrollPage.prototype.getItemName = function (item) {
        var name = item.name;
        if (this.isParent(item)) {
            name = item.title;
        }
        if (!name || name.length === 0) {
            name = item.name;
        }
        return name;
    };
    ItemGridScrollPage.prototype.change = function (b) {
        if (!this.scrollLock) {
            return;
        }
        if (!this.lastChangeEvent) {
            this.lastChangeEvent = b;
        }
        if (this.lastChangeEvent.startIndex === b) {
            return;
        }
        if (b.scrollStartPosition >= this.lastChangeEvent.scrollStartPosition) { // 向下滚
            if (b.startIndex < this.lastChangeEvent.startIndex || b.endIndex < this.lastChangeEvent.endIndex) {
                b.startIndex = Math.max(this.lastChangeEvent.startIndex, b.startIndex);
                b.endIndex = Math.max(this.lastChangeEvent.endIndex, b.endIndex);
            }
        }
        else { // 向上滚
            if (b.startIndex > this.lastChangeEvent.startIndex || b.endIndex > this.lastChangeEvent.endIndex) {
                // b.startIndex = this.lastChangeEvent.startIndex;
                // b.endIndex = this.lastChangeEvent.endIndex;
                b.startIndex = Math.min(this.lastChangeEvent.startIndex, b.startIndex);
                b.endIndex = Math.min(this.lastChangeEvent.endIndex, b.endIndex);
            }
        }
        var a;
        console.log('TCL: Tab1Page -> change -> startIndex: ' + b.startIndex + ';endIndex:' + b.endIndex);
        for (var i = 0; i < this.catArray.length; i++) {
            if (!this.catArray[i + 1]) {
                a = this.categories[this.catArray.length - 1];
                break;
            }
            else if (this.catArray[i] <= b.startIndex && b.startIndex < this.catArray[i + 1]) {
                a = this.categories[i];
                break;
            }
        }
        console.log('TCL: Tab1Page -> change -> cat', a.name);
        if (this.category.id !== a.id) {
            this.category = a;
            setTimeout(function () {
                var element = document.getElementById('active');
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            }, 500);
        }
        this.lastChangeEvent = b; // 保存最新的滚动事件event信息
        // console.log('TCL: Tab1Page -> change -> aa', b, a);
    };
    ItemGridScrollPage.prototype.settingMutlOrderManager = function () {
        if (this.multOrderManager.getOrderManager(this.storeId)) {
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
            this.orderManager.settingOrderType(this.orderManager.mode);
        }
        else {
            var orderManager = new OrderManager();
            orderManager.mode = this.orderManager.mode;
            orderManager.createOrder(this.storeId, null, null, null, this.store);
            this.multOrderManager.setOrderManagerMap(orderManager, this.storeId);
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
            this.orderManager.settingOrderType(this.orderManager.mode);
        }
    };
    ItemGridScrollPage.prototype.turnOffscrollChange = function () {
        var _this = this;
        this.scrollLock = false;
        setTimeout(function () {
            _this.scrollLock = true;
        }, 1000);
    };
    ItemGridScrollPage.prototype.catLayoutIsNone = function () {
        if (this.multOrderManager.enableMutlOrder) {
            this.settingMultOrderManager();
        }
        else if (this.orderManager.isEmpty()) {
            this.orderManager.createOrder(this.store.id, null, null, null, this.store);
            if (this.orderManager.mode === 'byod') {
                this.memberService.initMember('anno');
                this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
            }
        }
        this.orderManager.settingOrderType(this.orderManager.mode);
        this.showStore(this.store);
    };
    ItemGridScrollPage.prototype.settingMultOrderManager = function () {
        if (this.multOrderManager.getOrderManager(this.storeId)) {
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
        }
        else {
            var orderManager = new OrderManager();
            orderManager.mode = this.orderManager.mode;
            orderManager.createOrder(this.store.id, null, null, null, this.store);
            this.multOrderManager.setOrderManagerMap(orderManager, this.storeId);
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
        }
    };
    ItemGridScrollPage.prototype.showStore = function (store) {
        var cats = this.menuManager.getAvailableCategories(store, this.configService.getTime(), this.orderManager.mode === 'takeaway');
        if (!cats) {
            return;
        }
        this.categories = this.categoryFilter(cats, []);
        if (!this.categories || this.categories.length === 0) {
            this.promptNoCat();
        }
        if (!this.catImages || this.catImages.length === 0) {
            this.catImages = [];
            if (this.categories) {
                for (var _i = 0, _a = this.categories; _i < _a.length; _i++) {
                    var cat = _a[_i];
                    this.catImages.push(cat.getImage('default', 500, false));
                }
            }
        }
        this.category = this.categories[0];
        this.orderManager.store = store;
    };
    ItemGridScrollPage.prototype.promptNoCat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.noCat = true;
                        return [4 /*yield*/, this.alertController.create({
                                header: this.t.instant('pages.splash.no-cat-error'),
                                cssClass: 'sp-dineinTakeout-alert',
                                backdropDismiss: false,
                                buttons: [
                                    {
                                        text: this.t.instant('buttons.confirm'),
                                        handler: function () {
                                            // to do
                                            _this.backButtonClick();
                                        }
                                    }
                                ]
                            })];
                    case 1:
                        alert = _a.sent();
                        this.alert = alert;
                        this.alert.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.categoryFilter = function (cats, types) {
        var result = [];
        var typeCat = {};
        var tmp = cats.filter(function (cat) {
            if (!cat.users || cat.users.length === 0) {
                return true;
            }
            else {
                var tmpSet = new Set(cat.users);
                for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                    var type = types_1[_i];
                    console.log(type + ' cat name:', cat.name);
                    if (tmpSet.has(type)) {
                        if (!typeCat[type]) {
                            typeCat[type] = [];
                        }
                        typeCat[type].push(cat);
                        break;
                    }
                }
                return false;
            }
        });
        for (var type in typeCat) {
            result = result.concat(typeCat[type]);
        }
        this.normalCategories = this.normalCategories.concat(tmp);
        result = result.concat(tmp);
        return result;
    };
    ItemGridScrollPage.prototype.ngOnInit = function () {
        var _this = this;
        this.initCategory(this.category);
        if (this.isInfiniteScroll) {
            for (var i = 0; i < this.categories.length; i++) {
                var items = this.menuManager.getAvailableMainItems(this.store, this.categories[i], this.orderManager.isTakeout()) || [];
                var layout = this.categories[i].layout && this.categories[i].layout !== 'none' ? this.categories[i].layout : this.settings.itemLayout;
                if (!items) {
                    return;
                }
                items[0]['catName'] = this.categories[i].name; // 使每一个cat里的第一个item增加一个catName值.
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    // deal with the minprice
                    if (!item['minPrice'] && item.variations && item.variations.length > 0) {
                        item['minPrice'] = item.price;
                        for (var _a = 0, _b = item.variations; _a < _b.length; _a++) {
                            var tmp = _b[_a];
                            if (tmp.price < item['minPrice']) {
                                item['minPrice'] = tmp.price;
                            }
                        }
                    }
                    if (item) {
                        var img = void 0;
                        if (this.mode === 'list') {
                            img = item.getImage('default', 300, false); // 150
                        }
                        else {
                            img = item.getImage('default', 300, true); // 100
                        }
                        if (img) {
                            this.imgs.push(img);
                        }
                        else {
                            if (this.defaultImage) {
                                this.imgs.push(this.defaultImage);
                            }
                            else {
                                this.imgs.push(null);
                            }
                        }
                    }
                }
                this.setItemToScroll(items, layout);
                // for (let j = 0; j < items.length; j++) {
                //     if (items[j + 1]) {
                //         if (items[j].featured || items[j + 1].featured) {
                //             this.allAvailableItems.push([items[j]]);
                //         } else {
                //             this.allAvailableItems.push([items[j], items[j + 1]]);
                //             j++;
                //         }
                //     } else {
                //         this.allAvailableItems.push([items[j]]);
                //     }
                //     if (j === items.length - 1) {// 当前cat完成
                //         this.catArray.push(this.allAvailableItems.length);
                //     }
                // }
            }
            console.log('ngOnInit', this.allAvailableItems, this.catArray);
        }
        var badges = this.store.menu.badges;
        if (badges) {
            badges.forEach(function (badge) {
                var tagImg = badge.getImage('default', 400, true);
                if (tagImg) {
                    _this.tagsImage[badge.tag] = tagImg;
                }
            });
        }
    };
    // to deal with the grid3 push 3 item to this.allAvailableItems
    ItemGridScrollPage.prototype.setItemToScroll = function (items, layout) {
        var _this = this;
        var availableItems = []; // 储存 fetatured为false的item,直到item的数量符合要求或没有item 就push进 this.allAvailableItems
        var featuredItem = []; // 储存 featured为 true 的 [item] 数组 , 当 availableItems push进 this.allAvailableItems后 , 接着解构进 this.allAvailableItems
        items && items.forEach(function (item, index) {
            var _a, _b;
            if (item) {
                if (item.featured) {
                    if (availableItems.length === 0) {
                        _this.allAvailableItems.push([item]);
                    }
                    else {
                        featuredItem.push([item]);
                    }
                }
                else if (layout === 'grid3') {
                    availableItems.push(item);
                    if (availableItems.length === 3 || index === items.length - 1) {
                        _this.allAvailableItems.push(_this.pushItemEnough(availableItems));
                        // this.allAvailableItems.push(availableItems);
                        availableItems = [];
                        if (featuredItem !== []) {
                            (_a = _this.allAvailableItems).push.apply(_a, featuredItem);
                            featuredItem = [];
                        }
                    }
                }
                else {
                    availableItems.push(item);
                    if (availableItems.length === 2 || index === items.length - 1) {
                        _this.allAvailableItems.push(availableItems);
                        availableItems = [];
                        if (featuredItem !== []) {
                            (_b = _this.allAvailableItems).push.apply(_b, featuredItem);
                            featuredItem = [];
                        }
                    }
                }
            }
            if (index === items.length - 1) { // 当前cat完成
                _this.catArray.push(_this.allAvailableItems.length);
            }
        });
    };
    // to adjust the layout css
    ItemGridScrollPage.prototype.pushItemEnough = function (availableItems, number) {
        if (number === void 0) { number = 3; }
        while (availableItems && availableItems.length < number) {
            availableItems.push(false);
        }
        return availableItems;
    };
    ItemGridScrollPage.prototype.ngAfterViewInit = function () {
        this.iniTime = Date.now();
        gtag('event', 'Page Initialize', {
            'event_category': this.store.name + '(Item Grid Scroll Page)',
            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
            'value': 1
        });
        this.turnOffscrollChange();
        this.jumpToFloor(this.category);
        if (this.isInfiniteScroll) {
            setTimeout(function () {
                var element = document.getElementById('active');
                // console.log('element', element);
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            }, 600);
        }
        console.log('cate-to-grid level', this.orderService.gaTrack['cate-to-grid-level']);
        console.log('Enter time', this.iniTime);
        console.log('storeID', this.storeId);
    };
    ItemGridScrollPage.prototype.checkPopup = function (store) {
        return __awaiter(this, void 0, void 0, function () {
            var popupLocation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('TCL: checkPopup -> store', store);
                        popupLocation = 'welcome';
                        return [4 /*yield*/, this.layoutService.showPopup(store, popupLocation, function (data) {
                                console.log('ad data', data);
                                if (data && data.data) {
                                    var actionString = data.data.url;
                                    actionString = actionString.split('//')[1];
                                    // if (actionString === 'registration') {
                                    //     let page = this.memberService.getMember() ? MemberRewardPage : VerifyRegistrationPage;
                                    //     this.navController.push(page, {
                                    //         store: this.store,
                                    //         member: this.memberService.getMember(),
                                    //         fromPage: ByodSplashPage, logincb: () => {
                                    //             // this.next();
                                    //         }
                                    //     });
                                    // } else if (actionString === 'login' || actionString === 'loginbridge') {
                                    //     let page = null;
                                    //     if (actionString === 'login') {
                                    //         page = LoginPage;
                                    //     } else if (actionString === 'loginbridge') {
                                    //         page = LoginBridgePage;
                                    //     }
                                    //     // if(this.memberService.getMember())
                                    //     // {
                                    //     //     page = MemberRewardPage;
                                    //     // }
                                    //     if (page) {
                                    //         this.navController.push(page, {
                                    //             store: this.store,
                                    //             fromPage: ByodSplashPage, logincb: () => {
                                    //                 // this.next();
                                    //             }
                                    //         });
                                    //     }
                                    // }
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.ionViewWillEnter = function () {
        var element = document.getElementById('active');
        if (element) {
            element.scrollIntoView({ block: 'end', behavior: 'smooth' });
        }
    };
    ItemGridScrollPage.prototype.ionViewDidEnter = function () {
        this.enterTime = Date.now();
        console.log('Enter time', this.enterTime);
    };
    ItemGridScrollPage.prototype.ngOnDestroy = function () {
        var needAlert = true;
        // need a flag
        if (this.settings && this.settings.catLayout) {
            needAlert = this.settings.catLayout === 'none';
        }
        if (!this.multOrderManager.enableMutlOrder && needAlert) {
            this.orderManager.clear();
        }
        if (this.alert) {
            this.alert.dismiss();
        }
    };
    ItemGridScrollPage.prototype.initCategory = function (cat) {
        this.category = cat;
        this.bannerImg = this.category.getImage('banner', 500, false);
        this.variations = {};
        console.log('原始layout');
        if (this.isInfiniteScroll) {
            return;
        }
        var items = this.menuManager.getAvailableMainItems(this.store, this.category, this.orderManager.isTakeout());
        var filterItems = [];
        this.imgs = [];
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item) {
                filterItems.push(item);
                // deal with the minprice
                if (!item['minPrice'] && item.variations && item.variations.length > 0) {
                    item['minPrice'] = item.price;
                    for (var _a = 0, _b = item.variations; _a < _b.length; _a++) {
                        var tmp = _b[_a];
                        if (tmp.price < item['minPrice']) {
                            item['minPrice'] = tmp.price;
                        }
                    }
                }
                var img = void 0;
                if (this.mode === 'list') {
                    img = item.getImage('default', 300, false);
                }
                else {
                    img = item.getImage('default', 300, true);
                }
                if (img) {
                    this.imgs.push(img);
                }
                else {
                    if (this.defaultImage) {
                        this.imgs.push(this.defaultImage);
                    }
                    else {
                        this.imgs.push(null);
                    }
                }
            }
        }
        this.items = filterItems;
        for (var _c = 0, _d = this.items; _c < _d.length; _c++) {
            var item = _d[_c];
            this.findCategory(item);
        }
        if (this.isCatLayoutNone) {
            this.mode = this.category.layout && this.category.layout !== 'none' ? this.category.layout : this.settings.itemLayout;
        }
        if (!this.mode || this.mode === 'none') {
            this.mode = 'grid';
        }
        this.groups = cat.groups;
    };
    ItemGridScrollPage.prototype.isSet = function (item) {
        return Item.isSet(this.findCategory(item), item);
    };
    ItemGridScrollPage.prototype.findCategory = function (item) {
        var result = null;
        if (this.categoryMap[item.id]) {
            result = this.categoryMap[item.id];
        }
        else {
            var obj_1;
            this.categories.length > 0 && this.categories.map(function (category, index) {
                if (!obj_1) {
                    for (var i = 0; i < category.groups[0].items.length; i++) {
                        if (item.id === category.groups[0].items[i].id) {
                            obj_1 = category;
                            break;
                        }
                    }
                }
            });
            this.categoryMap[item.id] = obj_1;
            result = obj_1;
        }
        return result;
    };
    ItemGridScrollPage.prototype.addItem = function (item) {
        // this.orderService.addSingleItem(this.category, this.groups[0], item);
        var oi = this.orderManager.addSingleItem(this.findCategory(item), this.findCategory(item).groups[0], item, false);
        this.orderManager.getQuantity(item);
        if (!(this.isRequiredModifier(item) || (this.isModifiable(item) && !this.settings.quickSingleItem))) {
            // this.showToast(this.t.instant('global.item-added'), 600, 'bottom', 'add-item-toast');
        }
        return oi;
    };
    ItemGridScrollPage.prototype.cartClicked = function () {
        if (!this.memberService.getMember() && this.orderManager.mode === 'delivery') {
            console.log('not login and isDelivery ###', this.orderManager.getOrder());
            if (this.orderManager.getOrder().orderitems.length > 0) {
                // save the current Order
                this.configService.putPreference(this.orderManager.store.id + '.savedOrder', this.orderManager.getOrder());
            }
            // popUp delivery-login within modal
            // this.popUpDeliveryLogin();
            // force to push delivery-login within route
            this.pushByName('DeliveryLoginPage', {
                store: this.store,
                fromPage: 'ItemGridScrollPage',
                isRoute: true
            });
        }
        else {
            console.log('cart clicked', this.orderManager.order);
            gtag('event', 'GRID to CART page time spent(ms)', {
                'event_category': this.store.name + '(Item Grid scroll Page)',
                'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
                'value': Date.now() - this.enterTime
            });
            this.orderService.gaTrack['grid-to-cart-level'] += 1;
            gtag('event', 'Switch tab Count per level', {
                'event_category': this.store.name + '(Item Grid scroll Page)',
                'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
                'value': this.tabClickCount
            });
            gtag('event', 'Set clicked Count per level', {
                'event_category': this.store.name + '(Item Grid scroll Page)',
                'event_label': 'Level' + this.orderService.gaTrack['grid-to-cart-level'],
                'value': this.setClickCount
            });
            //   reset the tabClick of this level
            this.tabClickCount = 1;
            this.setClickCount = 0;
            if (this.orderService.isCourt ? this.multOrderManager.getOrders.length > 0 : this.orderManager.isEmpty()) {
                var warning = this.t.instant('global.order-first');
                var confirm_1 = this.t.instant('buttons.ok');
                this.showAlert('', warning, [confirm_1]);
            }
            else {
                this.pushByUrl((this.multOrderManager.enableMutlOrder ? RouteTable['MultiOrderCartPage'] : RouteTable['CartScrollPage']), { store: this.store });
            }
        }
    };
    ItemGridScrollPage.prototype.showAlertControlBDDismiss = function (title, message, buttons, enableBackdropDismiss) {
        if (buttons === void 0) { buttons = ['OK']; }
        if (enableBackdropDismiss === void 0) { enableBackdropDismiss = true; }
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!buttons) {
                            buttons = ['OK'];
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: title,
                                subHeader: message,
                                buttons: buttons,
                                backdropDismiss: enableBackdropDismiss
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/, alert];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.blockRepeatClick = function () {
        var _this = this;
        this.isBlockRepeatClick = true;
        setTimeout(function () {
            _this.isBlockRepeatClick = false;
        }, 400);
    };
    ItemGridScrollPage.prototype.addClicked = function (item, callBack) {
        return __awaiter(this, void 0, void 0, function () {
            var t, page, componentProps, cssClass, cate_1, oi, _groups, groups, oi, handler;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isBlockRepeatClick)
                            return [2 /*return*/];
                        this.blockRepeatClick();
                        console.log('add clicked', item);
                        return [4 /*yield*/, this.isVariationParent(item)];
                    case 1:
                        t = _a.sent();
                        console.log('variation parent', t);
                        if (t) {
                            return [2 /*return*/];
                        }
                        if (this.isSoldout(item)) {
                            return [2 /*return*/];
                        }
                        if (this.checkStoreMaxItem()) {
                            this.showStoreMaxItemAlert();
                            return [2 /*return*/];
                        }
                        if (this.isSet(item)) {
                            page = getSetLayout(this.orderManager.store.menu.setLayout);
                            componentProps = {
                                store: this.store,
                                category: this.findCategory(item),
                                groups: this.findCategory(item).groups,
                                item: item,
                                handler: this.getNavParams('handler')
                            };
                            gtag('event', 'Page from ENTERED to ADD COMBO time spent(ms)', {
                                'event_category': this.store.name + '(Item Grid scroll Page)',
                                'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
                                'value': Date.now() - this.enterTime
                            });
                            cssClass = 'modal-largescreen combo-modal-backdrop-dismiss';
                            this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, componentProps, {
                                relativeTo: this.route,
                                skipLocationChange: false
                            }, cssClass);
                        }
                        else {
                            // if cannot skip modifier page
                            if (this.isRequiredModifier(item) || (this.isModifiable(item) && !this.store.menu.quickSingleItem)) {
                                cate_1 = this.findCategory(item);
                                oi = this.addItem(item);
                                _groups = cate_1.groups, groups = _groups && _groups.filter(function (group) {
                                    return _this.menuManager.isAvailableGroup(_this.store, cate_1, group, _this.orderManager.isTakeout(), Date.now(), false);
                                });
                                this.add(item, groups[0], oi, false, callBack);
                                // this.pushByName('ModifierItemSelectPage', {store: this.store, orderitem: oi}, {
                                //     relativeTo: this.route,
                                //     //  // replaceUrl: true,
                                //     skipLocationChange: false
                                // });
                            }
                            else {
                                oi = this.addItem(item);
                                {
                                    if (!this.categories) {
                                        handler = this.getNavParams('handler');
                                        handler(oi);
                                        this.orderManager.minusItem(item, true);
                                        this.navigationService.popPage();
                                    }
                                }
                            }
                        }
                        if (this.orderService.isCourt) {
                            this.gaService.eventTrack('item-list-page', 'select item - ' + this.store.name, item.name);
                        }
                        this.bounce();
                        console.log(this.orderManager.getQuantity(item));
                        callBack && callBack();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.getGroupMode = function (group) {
        return group.repeat ? 'quantity' : 'single';
    };
    ItemGridScrollPage.prototype.getComponentMode = function (item) {
        var cat = this.findCategory(item);
        var mode = cat.layout && cat.layout !== 'none' ? cat.layout : this.settings.itemLayout;
        return mode;
    };
    ItemGridScrollPage.prototype.isGroupCompleted = function (group, index, quantity) {
        // console.log(group);
        if (!group) {
            return true;
        }
        if (group.min <= quantity || quantity === group.max) {
            return true;
        }
        if (group.optional) {
            if (group.skippable) {
                return true;
            }
            else {
                return index === -1;
            }
        }
        return false;
    };
    ItemGridScrollPage.prototype.presentModifierPopup = function (store, orderItem, group, itemMap, page, handler, showLastOne) {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = { store: store, orderitem: orderItem, group: group, itemMap: itemMap, side: true };
                        if (showLastOne) {
                            input['showLastOne'] = showLastOne;
                        }
                        return [4 /*yield*/, this.modalController.create({
                                component: page,
                                componentProps: input,
                                animated: true,
                                showBackdrop: false,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen modifier-modal',
                                enterAnimation: popUpAnimation,
                                leaveAnimation: popDrownAnimation
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (confirm) {
                            if (handler) {
                                handler(confirm);
                            }
                        });
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.getComboQuantity = function (item) {
        var order = this.orderManager.getOrder();
        if (order && order.orderitems && order.orderitems.length === 0) {
            return 0;
        }
        var finds = order.orderitems.filter(function (o) {
            var items = o.items || [];
            return items.find(function (i) {
                return i.id === item.id;
            });
        });
        return finds.length;
        // order.orderitems
    };
    ItemGridScrollPage.prototype.hasModifier = function (items, itemMap, checkRequired) {
        if (checkRequired === void 0) { checkRequired = false; }
        var required = false;
        for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
            var item = items_3[_i];
            var tmpItem = itemMap[item.id];
            if (tmpItem && tmpItem.mgroups && tmpItem.mgroups.length > 0) {
                if (checkRequired) {
                    for (var _a = 0, _b = tmpItem.mgroups; _a < _b.length; _a++) {
                        var mgroup = _b[_a];
                        if (mgroup.min && mgroup.min > 0) {
                            required = true;
                            break;
                        }
                    }
                }
                else {
                    required = true;
                    break;
                }
            }
        }
        return required;
    };
    ItemGridScrollPage.prototype.handlingModifier = function (oi, item, itemMap, addHandler, notAddHandler, showLastOne) {
        if (showLastOne === void 0) { showLastOne = false; }
        var group = oi.groups[0];
        var items = [];
        items.push(item);
        var req = this.hasModifier(items, itemMap, this.settings.quickSingleItem);
        if (req) {
            this.presentModifierPopup(this.store, oi, group, itemMap, SideBarModifierDialog, function (confirm) {
                if (confirm && confirm['data']) {
                    addHandler();
                }
                else {
                    notAddHandler(item);
                }
            }, showLastOne);
        }
        else {
            addHandler();
        }
    };
    ItemGridScrollPage.prototype.add = function (item, group, oi, isPreselect, callBack) {
        var _this = this;
        if (isPreselect === void 0) { isPreselect = false; }
        var groupIndex = item.groups.findIndex(function (g) {
            // TODO: is compared by id safe?
            return (g !== null && g !== undefined && g.id === group.id);
        }) + 1;
        var isOptional = group.min === 0;
        if (this.getGroupMode(group) === 'single') {
            // special request only can change isSelected
            var max = group.max;
            var able = true;
            if (!isPreselect) {
                if (this.isGroupCompleted(group, groupIndex, 1)) {
                    this.handlingModifier(oi, item, this.itemMap, function () {
                    }, function () {
                        // this.minusClicked(item, group);
                        _this.removeClicked(item, callBack);
                    });
                }
                else if (isOptional) {
                    var realItem = item;
                    if (realItem.mgroups && realItem.mgroups.length > 0) {
                        this.handlingModifier(oi, item, this.itemMap, function () {
                            // this.showToast(this.t.instant('global.item-added'));
                        }, function () {
                            // this.minusClicked(item, group);
                            _this.removeClicked(item);
                        }, true);
                    }
                }
            }
        }
        else if (this.getGroupMode(group) === 'quantity') {
            // special request can change the number
        }
    };
    ItemGridScrollPage.prototype.removeClicked = function (item, callBack) {
        console.log('remove clicked');
        // this.orderService.deleteItem(item);
        // this.orderService.minusItem(item);
        this.orderManager.minusItem(item, true);
        callBack && callBack();
    };
    ItemGridScrollPage.prototype.bounce = function () {
        var _this = this;
        this.isBounce = true;
        setTimeout(function () {
            _this.isBounce = false;
        }, 400);
    };
    ItemGridScrollPage.prototype.getModifierString = function (item) {
        var modifiers = '+';
        var groups = this.findCategory(item).groups;
        if (item.groups && item.groups.length > 0) {
            groups = item.groups;
        }
        else {
            groups = groups.slice(1);
        }
        groups = groups.filter(function (group) { return group.items && group.items.length > 0; });
        if (!groups || groups.length === 0) {
            return '';
        }
        return modifiers + groups.map(function (group) { return group.name; }).join(' +');
    };
    ItemGridScrollPage.prototype.triggerFab = function () {
        this.googleAnalyticEventTrack('menu');
        this.isfabOpen = !this.isfabOpen;
        if (!this.isfabOpen) {
            this.googleAnalyticEventTrack('close menu', 'open menu');
        }
    };
    // 点击catbar
    ItemGridScrollPage.prototype.catClicked = function (fab, cat) {
        var _this = this;
        if (this.isfabOpen) {
            this.googleAnalyticEventTrack('choose cate', 'open menu');
        }
        var warning = (cat && cat['warning']) || null;
        if (warning /* && StaticService.canShowWarning*/) {
            var buttons = [
                {
                    text: this.t.instant('buttons.cancel'),
                    handler: function (value) {
                    }
                },
                {
                    text: this.t.instant('buttons.ok'),
                    handler: function (value) {
                        if (_this.isInfiniteScroll) {
                            _this.category = cat;
                        }
                        else {
                            _this.initCategory(cat);
                        }
                        _this.mode = cat.layout && cat.layout !== 'none' ? cat.layout : _this.settings.itemLayout;
                        if (!_this.mode || _this.mode === 'none') {
                            _this.mode = 'grid';
                        }
                        _this.isfabOpen = false;
                        // fab.close();
                    }
                }
            ];
            this.showAlertControlBDDismiss(null, warning, buttons, false);
        }
        else {
            if (this.isInfiniteScroll) {
                this.category = cat;
            }
            else {
                this.initCategory(cat);
            }
            this.mode = cat.layout && cat.layout !== 'none' ? cat.layout : this.settings.itemLayout;
            if (!this.mode || this.mode === 'none') {
                this.mode = 'grid';
            }
            this.isfabOpen = false;
            // fab.close();
        }
        this.turnOffscrollChange();
        this.isInfiniteScroll && this.jumpToFloor(cat);
        this.cdr.detectChanges();
    };
    ItemGridScrollPage.prototype.jumpToFloor = function (cat) {
        var i = 0;
        for (i = 0; i < this.categories.length; i++) {
            if (cat.id === this.categories[i].id) {
                break;
            }
        }
        console.log('jump', this.catArray, i);
        if (this.scroll)
            this.scroll.scrollToIndex(this.catArray[i]);
    };
    ItemGridScrollPage.prototype.checkStoreMaxItem = function () {
        var maxItems = this.orderManager.store.menu.maxItems;
        var infinity = maxItems === 0;
        return (maxItems <= this.orderManager.count && !infinity);
    };
    ItemGridScrollPage.prototype.backButtonClick = function () {
        console.log('back click');
        this.orderService.gaTrack['cate-to-grid-level'] += 1;
        if (this.navigationService.poping || this.navigationService.navigating) {
            return;
        }
        gtag('event', 'Page from ENTERED to BACK DESTROY time spent(ms)', {
            'event_category': this.store.name + '(Item Grid Page)',
            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
            'value': Date.now() - this.iniTime
        });
        var needAlert = true;
        // need a flag
        if (this.settings && this.settings.catLayout) {
            needAlert = this.settings.catLayout === 'none';
        }
        _super.prototype.backButtonClick.call(this);
    };
    ItemGridScrollPage.prototype.isModifiable = function (item) {
        if (!this.modifiableMap[item.id]) {
            this.modifiableMap[item.id] = Item.isModifiable(item);
        }
        return this.modifiableMap[item.id];
    };
    ItemGridScrollPage.prototype.isRequiredModifier = function (item) {
        if (this.isModifiable(item)) {
            if (!this.requiredModifierMap[item.id]) {
                this.requiredModifierMap[item.id] = item.mgroups.some(function (mgroup) { return mgroup.min > 0; });
            }
            return this.requiredModifierMap[item.id];
        }
        else {
            return false;
        }
    };
    // new list function //
    ItemGridScrollPage.prototype.getImage = function (data) {
        if (this.imageMap[data.id]) {
            return this.imageMap[data.id];
        }
        else {
            var img = data.getImage('default', 300, true);
            this.imageMap[data.id] = img;
            return img;
        }
    };
    ItemGridScrollPage.prototype.isSoldout = function (item) {
        var result = false;
        if (this.itemSoldoutMap[item.id]) {
            var cache = this.itemSoldoutMap[item.id];
            result = !!cache['soldout'];
        }
        else {
            var imSoldout = this.inventoryManager.isSoldout(item);
            result = (!this.isParent(item) && imSoldout);
            this.itemSoldoutMap[item.id] = { 'soldout': result };
        }
        var now = new Date().getTime();
        return result || !this.menuManager.isAvailableCombo(this.store, this.findCategory(item), item, this.orderManager.isTakeout(), now);
    };
    ItemGridScrollPage.prototype.pageName = function () {
        return '/item-grid';
    };
    ItemGridScrollPage.prototype.isVariationParent = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var exist, items, input, modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exist = this.isParent(item);
                        if (!exist) return [3 /*break*/, 2];
                        items = item.variations.slice(0) || [];
                        if (item.id === item.parentId) {
                            items.splice(0, 0, item);
                        }
                        else {
                            items.push(item);
                        }
                        input = { items: items, store: this.store, category: this.findCategory(item), orderManager: this.orderManager };
                        console.log('isVariationParent input', input);
                        return [4 /*yield*/, this.modalController.create({
                                component: VariationScrollDialog,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen',
                                animated: true,
                                enterAnimation: popUpAnimation,
                                leaveAnimation: popDrownAnimation
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onWillDismiss().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var selected, page, params, cssClass, oi, params, m;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        selected = (data['data']);
                                        if (!selected) return [3 /*break*/, 3];
                                        console.log('select & add item,', selected);
                                        if (this.checkStoreMaxItem()) {
                                            this.showStoreMaxItemAlert();
                                            return [2 /*return*/];
                                        }
                                        if (!(this.isSet(selected) || selected.pgroup)) return [3 /*break*/, 1];
                                        page = getSetLayout(this.orderManager.store.menu.setLayout);
                                        params = {
                                            store: this.store,
                                            category: this.findCategory(item),
                                            groups: this.findCategory(item).groups,
                                            item: selected
                                        };
                                        console.log('set layout', page);
                                        gtag('event', 'Page from ENTERED to ADD COMBO(has parent) time spent(ms)', {
                                            'event_category': this.store.name + '(Item Grid scroll Page)',
                                            'event_label': 'Level' + this.orderService.gaTrack['cate-to-grid-level'],
                                            'value': Date.now() - this.enterTime
                                        });
                                        cssClass = 'modal-largescreen set-list-view combo-modal-backdrop-dismiss';
                                        this.navToAssignLayoutItems(page === 'MultiStepComboPage'
                                            ? MultiStepComboPage : ComboPage, page, params, {
                                            relativeTo: this.route,
                                            skipLocationChange: false,
                                        }, cssClass);
                                        return [3 /*break*/, 3];
                                    case 1:
                                        oi = this.addItem(selected);
                                        if (!(this.isRequiredModifier(selected) || (this.isModifiable(selected) && !this.store.menu.quickSingleItem))) return [3 /*break*/, 3];
                                        params = { store: this.store, orderitem: oi, edit: true };
                                        return [4 /*yield*/, this.modalController.create({
                                                component: ModifierItemSelectPageModal,
                                                componentProps: params,
                                                showBackdrop: false,
                                                enterAnimation: popUpAnimation,
                                                leaveAnimation: popDrownAnimation,
                                                cssClass: 'modal-largescreen variation-item-modifier-select'
                                            })];
                                    case 2:
                                        m = _a.sent();
                                        m.onDidDismiss().then(function (data) {
                                            console.log('ModifierItemSelectPageModal res', data);
                                            if (data['data'] === 'confirm') {
                                                // do....
                                                // this.showToast(this.t.instant('global.item-added'));
                                            }
                                            else {
                                                _this.removeClicked(selected);
                                            }
                                        });
                                        m.present();
                                        return [3 /*break*/, 3];
                                    case 3:
                                        this.isVariationOpened = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.isVariationOpened = true;
                        modal.present();
                        _a.label = 2;
                    case 2: return [2 /*return*/, exist];
                }
            });
        });
    };
    ItemGridScrollPage.prototype.isParent = function (item) {
        return !!(item.variations && item.variations.length > 0);
    };
    return ItemGridScrollPage;
}(MobileBasePage));
export { ItemGridScrollPage };
